import { render, staticRenderFns } from "./Diabolocom.vue?vue&type=template&id=dfc7cf90&"
import script from "./Diabolocom.vue?vue&type=script&lang=js&"
export * from "./Diabolocom.vue?vue&type=script&lang=js&"
import style0 from "./Diabolocom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports